var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mainHeader'),(_vm.canSysAdminAccess || _vm.canStudyAdminAccess)?_c('div',{staticClass:"has-header"},[_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }